/**
 * @description Icons
 * @param  {Object} customStyle 自定义样式 默认 ''
 * @param  {String} customClassName 自定义类 默认 ''
 * @param  {String} type icon类型 默认 ''
 * @param  {Function} handleClick 点击事件
 */
import React from 'react'
import IconDatas from '../../config/iconUtil';
import '../../assets/less/icons.less'
const Icons = (props) => {
   const {customStyle={}, customClassName='', type='', handleClick} = props
   const selectIcon = IconDatas[type] || null
   return <span onClick={()=> {handleClick && handleClick()}} className={`aia-bx-icon ${customClassName} aia-bx-icon-${type}`} style={customStyle}>
       {
         selectIcon && selectIcon()
       }
   </span>
}
// Icons.defaultProps = {
//     customStyle: {}, type: '', customClassName: ''
//   }
export default Icons